<div class="row ">
  
    <div class="col-md-9 pos-relative"> 
      <f-data-card class="onDemand-email">
        <div class="row row-bottom-space">
            <div class="col-md-12">
              <h2>On Demand Email</h2>
            </div>
            <section class="error-wrapper" *ngIf="rootScopeService.activeCustTab.onDemandEmailData.onDemandEmailConfigMiss">
              <f-alert variant="error">
                <p class="full-width">
                  There is no email template configured for the client. Please try later.
                </p>
              </f-alert>
            </section>
            <section class="error-wrapper" *ngIf="rootScopeService.activeCustTab.onDemandEmailData.onDemandEmailApiFailure">
              <f-alert variant="error">
                <p>
                  There was an issue loading the template. <a href="javascript:void('0')"
                    (click)="onDemandEmailService.getOnDemandEmailConfigFromServer()" class="btn-alert">Try again.</a>
                </p>
              </f-alert>
            </section>
           

        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="left-nav">
              <ul >
                <li>
                  <button class="no-child-tab active"> 
                    <f-icon icon-config='{"iconName": "envelope", "iconType": "light", "iconSize": "s"}'></f-icon> 
                    <span>Send Email </span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-9 right-panel">
            <form [formGroup]="onDemandEmailService.onDemandForm"   >

            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="fill" class="component-box">
                  <mat-label> Select template (required)</mat-label>
                  <mat-select disableRipple disableOptionCentering (selectionChange)="onTemplateSelection($event)" formControlName="template" placeholder="Select template (required)">
                    <mat-option *ngFor="let template of rootScopeService.activeCustTab.onDemandEmailData?.emailTemplateList" [value]="template.name">
                      {{ template.name }}
                    </mat-option>
                  </mat-select>

                </mat-form-field>
              </div>
            </div> 
            
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="fill" class="component-box multiple-email-box">
                  <mat-label>To</mat-label>
                  <mat-chip-list #chipList aria-label="Email chip list" formControlName="email">
                    <mat-chip *ngFor="let email of emails" [selectable]="true" [removable]="true" (removed)="remove(email)">
                      {{ email }}
                      <mat-icon matChipRemove *ngIf="removable"> <f-icon icon-config='{"iconName": "xmark", "iconType": "light", "iconSize": "s"}'></f-icon></mat-icon>
                    </mat-chip>
            
                    <!-- Invalid Emails as plain text -->
                    <span *ngFor="let invalidEmail of invalidEmails" class="invalid-email">
                      {{ invalidEmail }}
                      <button mat-icon-button (click)="remove(invalidEmail)">
                        <f-icon icon-config='{"iconName": "xmark", "iconType": "light", "iconSize": "s"}'></f-icon>
                      </button>
                    </span>
            
            
                    <input [placeholder]="(emails.length === 0 && invalidEmails.length === 0) ? 'name@email.com' : '' "
                      [matChipInputFor]="chipList"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes" 
                      [matChipInputAddOnBlur]="true"
                      (matChipInputTokenEnd)="add($event)" />
                  </mat-chip-list>          
                <mat-error *ngIf="onDemandEmailService.onDemandForm.get('email')?.invalid ">
                  <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>
                    
                    {{ getEmailErrorMessage() }}
                  
                  </mat-error>
                </mat-form-field>
              </div>
            </div>         
           
           <div class="row">
            <div class="col-md-12 ">
                <h4>Subject</h4>
                <mat-form-field appearance="fill" class="component-box no-label">
                   <input matInput formControlName="title" [maxlength]="100" />
                </mat-form-field>
            </div>            
           </div>         
           
        <div class="row">              
              <div class="col-md-12">
                <h4>Body</h4>

                  <f-textarea  class="component-box no-label" formControlName="description"></f-textarea>
              </div>
          </div> 

        <div class="row ">
            <div class="col-md-12">
            <h4> Attachment(s)</h4>
            <ul class="attachment-list">
              <li *ngFor="let attachment of rootScopeService.activeCustTab.onDemandEmailData.selectedTemplateList?.attachementName"> <f-icon icon-config='{"iconName": "paperclip", "iconType": "light", "iconSize": "s"}'></f-icon>{{ attachment }}</li>
            </ul>
            
            </div>
        </div>
          
        <div class="row row-bottom-space">
            <div class="col-md-12">
                <div class="button-controls">
                    <f-button text="Clear all" title="Clear all" (click)="clearForm()" type="button" variant="action"></f-button>
                    <f-button text="Send" title="Send" [disabled]="!onDemandEmailService.onDemandForm.valid || emails.length === 0 || invalidEmails.length > 0"
                      (click)="sendEmailButtonClicked()" type="button" variant="progressive"></f-button>
                </div>
            </div>
            </div>
            </form>
          </div>
  
        </div>
      </f-data-card>
  
    </div>
  </div> 